<div class="container">
    <div class="bg-light my-4 p-4">
        <div class="card">
            <h1>404</h1>
        </div>
        <h5><a routerLink="/home" routerLinkActive="active" class="pb-5">&laquo; Back to the main page</a></h5>
    </div>
</div>